import { render } from "./BaumlisteEditor.vue?vue&type=template&id=1064e06c&scoped=true"
import script from "./BaumlisteEditor.vue?vue&type=script&lang=js"
export * from "./BaumlisteEditor.vue?vue&type=script&lang=js"

import "../forms/form.css?vue&type=style&index=0&id=1064e06c&scoped=true&lang=css&external"
import "./BaumlisteEditor.vue?vue&type=style&index=1&id=1064e06c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1064e06c"]])

export default __exports__